<div class="calculator">
    <mat-accordion> 
        <mat-expansion-panel *ngIf="quote.quote_versions[0].is_aeio == 1 || quote.indicativePage"
            [expanded]="quote.quote_versions[0].is_aeio == 1 || !quote.full_quote_section" [hidden]="quote.hideAEIOCal">
            <mat-expansion-panel-header>
                <mat-panel-title class="cal_header">
                    AEIO Quote Details
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="cal_body p-3 bg-white">
                <h5>Accidental, External (Visible) Injury Only (A.E.I.O) <span (click)="helpTextPopup(content)"><i
                            class="mdi mdi-comment-question-outline ml-1"></i></span>
                </h5>
                <p>
                    <b>Policy premium</b><br>&pound;{{calculationsDe.aeio_total_gross_primum}}
                </p>
                <p>
                    <b>Broker commission</b><br>&pound;{{calculationsDe.aeio_broker_amount}}
                </p>
                <p>
                    <b>Insurance premium tax (12%)</b><br>&pound;{{calculationsDe.aeio_ipt_gross_amount}}
                </p>
                <p>
                    <b>Total premium</b><br>&pound;{{calculationsDe.aeio_total_premium}}
                </p>
                <p>
                    <b>Fees</b><br>&pound;{{calculationsDe.aeio_underwriting_fee}}
                </p>
                <p>
                    <b>Total cost of the policy</b><br>&pound;{{calculationsDe.aeio_total_amount_payable}}
                </p>
            </div>
        </mat-expansion-panel>
        <mat-expansion-panel class="mt-2"
            *ngIf="quote.full_quote_section && (quote.quote_versions[0].is_aeio == 0 || quote.indicativePage)"
            [expanded]="quote.quote_versions[0].is_aeio == 0 ">
            <mat-expansion-panel-header>
                <mat-panel-title class="cal_header">
                    Full Quote Details
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="cal_body p-3 bg-white">
                <h5> Full Quote</h5>
                <p>
                    <b>Policy premium</b><br>&pound;{{calculationsDe.full_total_gross_primum}}
                </p>
                <p>
                    <b>Broker commission</b><br>&pound;{{calculationsDe.full_broker_amount}}
                </p>
                <p>
                    <b>Insurance premium tax (12%)</b><br>&pound;{{calculationsDe.full_ipt_gross_amount}}
                </p>
                <p>
                    <b>Total premium</b><br>&pound;{{calculationsDe.full_total_premium}}
                </p>
                <p>
                    <b>Fees</b><br>&pound;{{calculationsDe.full_underwriting_fee}}
                </p>
                <p>
                    <b>Total cost of the policy</b><br>&pound;{{calculationsDe.full_total_amount_payable}}
                </p>
            </div>
        </mat-expansion-panel>
    </mat-accordion>

</div>
<ng-template #content let-modal>
    <div class="modal-body">
        Accidental,
        External, (Visible) Injury Only – physical external damage or external trauma to a horse arising
        from a sudden accidental, unexpected specific event that occurs at an identifiable time and
        place and results in a visible external wound only and/or bone fracture. It cannot be caused by
        an illness or disease.
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-default btn-gray" (click)="modal.close()">Close</button>
    </div>
</ng-template>